import { render, staticRenderFns } from "./TchFooter.vue?vue&type=template&id=f1f42ae4&scoped=true"
import script from "./TchFooter.vue?vue&type=script&lang=js"
export * from "./TchFooter.vue?vue&type=script&lang=js"
import style0 from "./TchFooter.vue?vue&type=style&index=0&id=f1f42ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f42ae4",
  null
  
)

export default component.exports